export type PlacesLocationBias = {
  latitude: number;
  longitude: number;
  /** Defaults to 250 km when omitted. */
  radiusMeters?: number;
};

/** Places API (New) caps circle.radius at 50,000m — larger values 400 the whole request. */
export const BUSINESS_LOCATION_BIAS_RADIUS_METERS = 50_000;

export const toPlacesApiLocationBias = (bias: PlacesLocationBias) => ({
  circle: {
    center: {
      latitude: bias.latitude,
      longitude: bias.longitude,
    },
    radius: Math.min(
      bias.radiusMeters ?? BUSINESS_LOCATION_BIAS_RADIUS_METERS,
      BUSINESS_LOCATION_BIAS_RADIUS_METERS,
    ),
  },
});
